import React from "react";
import "../screen/signup.css";
import logo from '../assets/img/logo.png'
import slogan from '../assets/img/slogan.png'

export default class Header extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    return <div className='container'>
        <div className='row mb-5 border-bottom'>
            <div className='col-md-4 '>
                <img src={logo} width='140px' />
            </div>
            <div className='col-md-8 text-left'>
                <img src={slogan} width='70%' />
            </div>
        </div>
    </div>;
  }
}
